<template>
	<div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="createTaskModallLabel" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
                    <h5 class="modal-title" id="createTaskModalLabel">{{$t('scheduler.gridHeaders.eventName')}}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<kendo-tabstrip>
						<ul>
							<li class="k-state-active">{{ $t('tasks.details') }}</li>
						</ul>
						<div>
                            <div class="row">
                                <div class="col-md-12 form-group">
                                    <label class="font-weight-bold">{{$t('registers.events.evaluation.tempRanking.eventName')}}</label>
                                    <div>{{model.eventName}}</div>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="font-weight-bold">{{$t('registers.events.evaluation.tempRanking.eventStartDate')}}</label>
                                    <div>{{moment(model.eventStartDate).format('DD.MM.YYYY HH:mm')}}</div>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="font-weight-bold">{{$t('registers.events.evaluation.tempRanking.eventEndDate')}}</label>
                                    <div>{{moment(model.eventEndDate).format('DD.MM.YYYY HH:mm')}}</div>
                                </div>
                                <div class="col-md-12 form-group">
                                    <label class="font-weight-bold">{{$t('scheduler.lecturers')}}</label>
                                    <div>
                                        <ul>
                                            <li v-for="lecturer in model.lecturers">{{lecturer.fullName}}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-12 form-group">
                                    <label class="font-weight-bold">{{$t('scheduler.coordinators')}}</label>
                                    <div>
                                        <ul>
                                            <li v-for="coordinator in model.coordinators">{{coordinator.fullName}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
						</div>
					</kendo-tabstrip>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('buttons.close')}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { EventDetails } from '../../models/models';
import moment from 'moment';

export default {
	components: {
		
	},
	props: {
		value: {},
		show: {
			type: Boolean,
			required: false
		}
	},
	data() {
		return {
			model: new EventDetails(),
			moment: moment
		};
	},
	methods: {
		hide() {
			$(this.$el).modal('hide');
		},
		onClose() {
			this.$emit('onClose');
		}
	},
	mounted() {
		//add modal close listener
		$(this.$el).on('hidden.bs.modal', this.onClose);
	},
	beforeDestroy() {
		//remove listener
		$(this.$el).off('hidden.bs.modal');
	},
	watch: {
		show: function(val) {
			if (val) {
				this.model = new EventDetails({ ...this.value });
				$(this.$el).modal('show');
			} else {
				$(this.$el).modal('hide');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.bmd-form-group {
	padding-top: 0px;
}
</style>
